export default __webpack_public_path__ + "static/media/secureData.12d883e7.svg";